import api from '../../../configs/api'

import Form from '../../../display/forms/FormElements'

import Method from '../../../net/Method'

import Person        from '../../../things/Person'
import PropertyValue from '../../../things/PropertyValue'
import Thing         from '../../../things/Thing'

const people =
{
    add :
    {
        agree       : 'Ajouter' ,
        disagree    : 'Annuler' ,
        description : 'Veuillez sélectionner une personne en cliquant ci-dessous.' ,
        elements    :
        [
            {
                type       : Form.SEARCH_SELECTOR ,
                path       : api.people.url ,
                clazz      : Person ,
                clearLabel : 'Vider' ,
                closeLabel : 'Fermer' ,
                init       :
                {
                    id         : 'value',
                    key        : 'value',
                    label      : 'Personne',
                    autoFocus  : false,
                    fullWidth  : true,
                    margin     : 'normal',
                    required   : true,
                    type       : 'search',
                    variant    : 'outlined'
                },
                inputProps :
                {
                    label : 'Personne...'
                },
                logics :
                    {
                        disabledSuggestions : ( props ) =>
                        {
                            const { rel } = props ;
                            if( rel instanceof Thing )
                            {
                                const { subjectOf } = rel ;
                                if( subjectOf instanceof Thing )
                                {
                                    const { people } = subjectOf ;
                                    if( people instanceof Array )
                                    {
                                        return people ;
                                    }
                                }
                            }
                            return null ;
                        }
                    }
            }

        ],
        fail    : 'Veuillez corriger les erreurs ci-dessous!' ,
        loading : 'Chargement en  cours...' ,
        method  : Method.POST,
        prepare : ( item ) =>
        {
            return (
            {
                value : item.value
            });
        },
        mapUri : ( item , uri ) =>
        {
            if( item instanceof PropertyValue)
            {
                const { value } = item ;
                if( value instanceof Thing )
                {
                    return uri + '/' + value.id ;
                }
            }
            return uri ;
        },
        success : 'Ajout de la personne réussi!' ,
        title   : 'Ajouter une personne'
    },
    remove :
    {
        agree       : 'Supprimer' ,
        description : 'Souhaitez-vous supprimer cette personne:' ,
        disagree    : 'Annuler' ,
        loading     : 'Suppression en cours...' ,
        title       : 'Supprimer la personne ?'
    },
    title : 'Personnes' ,
    tooltips :
    {
        add    : "Ajouter" ,
        edit   : "Éditer" ,
        remove : "Supprimer"
    }
};

export default people ;
